import { ScrollView } from 'react-native'

import { useRoute } from '@react-navigation/native'
import { colors as zetColors } from '@zet/design-system'
import { YStack } from '@zet/design-system/layout'
import { SH3 } from '@zet/design-system/typography'
import { APP_NAME } from '@zet/end-points'
import { i18n } from '@zet/localization'
import ZindagiSet from '@zet/svg/zetPartner.svg'

import BrandBenifitsContent from './brandBenifitsContent'

export const BrandBenefits = () => {
  const { params } = useRoute()
  const brandId = params?.brandId
  const variantId = params?.variantId

  return (
    <ScrollView className="bg-grays-30 flex-1">
      <BrandBenifitsContent brandId={brandId} variantId={variantId} />
      {APP_NAME === 'zet-app' && (
        <>
          <YStack className="mt-5 items-center">
            <ZindagiSet size={80} color={zetColors.grays[40]} />
          </YStack>
          <SH3 className="text-grays-60 text-center">
            {i18n.t('brandBenifits.bringingFinancialProductsForBharat')}
          </SH3>
        </>
      )}
    </ScrollView>
  )
}
